import type { Opportunity } from '@/types/Opportunity'

export const shouldShowPricingIndicator = (opportunity: Opportunity) => {
  return (
    (opportunity?.showPricingIndicator &&
      !!opportunity?.lowestBid &&
      !!opportunity?.isLowest) ||
    (opportunity?.showPricingIndicator && !!opportunity?.cheapestQuoteAmount)
  )
}
